module.exports = __webpack_public_path__ + "img/example4mini.22222627.webp";